export const state = () => ({
  invoices: [],
  invoiceDetail: {},
  transactions: []
});

export const mutations = {
  SET_INVOICES: function(state, invoices) {
    state.invoices = invoices;
  },
  SET_INVOICES_DETAIL: function(state, invoiceDetail) {
    state.invoiceDetail = invoiceDetail;
  },
  SET_TRANSACTIONS: function(state, transactions) {
    state.transactions = transactions;
  }
};
export const actions = {
  getInvoices({ dispatch, state, commit }, params) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`app_subscriptions/invoices`, {
          params: { location_id: $nuxt.$ls.get("selected-location-id") }
        })
        .then(function(response) {
          commit("SET_INVOICES", response.data.invoices);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getInvoiceDetail({ dispatch, state, commit }, { id, params }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`app_subscriptions/invoices/${id}`, { params })
        .then(function(response) {
          commit("SET_INVOICES_DETAIL", response.data.invoices);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  initPayment({}, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`app_subscriptions/initiate_payment`, payload)
        .then(function(response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  paymentSuccess({}, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`app_subscriptions/payment_success`, payload)
        .then(function(response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  paymentFailed({}, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`app_subscriptions/payment_failure`, payload)
        .then(function(response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getTransactions({ commit }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`transactions`, {
          params: { location_id: $nuxt.$ls.get("selected-location-id") }
        })
        .then(function(response) {
          commit("SET_TRANSACTIONS", response.data?.transactions);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  }
};
export const getters = {
  pendingInvoices(state) {
    return state.invoices.filter(
      (invoice) => invoice.payment_status == "not_paid"
    );
  },
  completedInvoices(state) {
    return state.invoices.filter((invoice) => invoice.payment_status == "paid");
  }
};
